import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	iconLabel: {
		id: 'contextual-summary.common.ui.error-state.icon-label',
		defaultMessage: 'Warning icon',
		description: 'Icon label used for accessibility purposes. Icon shows an warning sign.',
	},

	errorMessageWithSupportLinkShort: {
		id: 'contextual-summary.common.ui.error-message-with-support-link-short',
		defaultMessage:
			'<heading>Something went wrong</heading> <text>Try refreshing, or</text> <link>contact support</link>',
		description:
			'Message displayed to users when an error happens while loading the content of an individual gadget on the summary page. The <heading> <text> and <link> tags will be replaced by an atlaskit component.',
	},
	errorMessageWithSupportLinkLong: {
		id: 'contextual-summary.common.ui.error-message-with-support-link-long',
		defaultMessage:
			"<heading>Something went wrong</heading> <text>Try again by refreshing and if that doesn't fix it,</text> <link>contact support</link>",
		description:
			'Message displayed to users when an error happens while loading the content of an individual gadget on the summary page. The <heading> <text> and <link> tags will be replaced by an atlaskit component.',
	},
	errorMessageWithRefreshButtonShort: {
		id: 'contextual-summary.common.ui.error-message-with-refresh-button-short',
		defaultMessage:
			'<heading>Something went wrong</heading> <text>Try refreshing</text> <button>Refresh</button>',
		description:
			'Message displayed to users when an error happens while loading the content of an individual gadget on the summary page. The <heading> <text> and <button> tags will be replaced by an atlaskit component. the refresh button attempts to retry fetching the data for the current gadget',
	},
	errorMessageWithRefreshButtonLong: {
		id: 'contextual-summary.common.ui.error-message-with-refresh-button-long',
		defaultMessage:
			'<heading>Something went wrong</heading> <text>Try again by refreshing this section.</text> <button>Refresh</button>',
		description:
			'Message displayed to users when an error happens while loading the content of an individual gadget on the summary page. The <heading> <text> and <button> tags will be replaced by an atlaskit component. the refresh button attempts to retry fetching the data for the current gadget',
	},
});
